<template>
  <div v-if="dialogVisible" class="recommend-authorization">
    <div class="dialog-close-btn" @click="close">X</div>
    <div class="authorization-alert-box">
      <p>邀请候选人接受委托你将得到什么？：</p>
      <p>1.候选人接受授权后系统会进行记录，帮助大家以后和人选battle</p>
      <p>2.授权后所有面试安排和面试反馈可选择通过线上平台发送给候选人，提高大家的效率</p>
      <p>3.加分！加分！加分!体系化积分它不香吗？！</p>
    </div>
    <div v-if="!imgUrl" class="content-box">
      <p>首先确认在《委托协议》中是否展示真实的客户公司名字：</p>
      <div class="radio-box">
        <el-radio v-model="radio" label="真实">展示客户公司真实名字</el-radio>
        <el-radio v-model="radio" label="脱敏">展示脱敏名字</el-radio>
      </div>
      <div class="authorization-box">
        <p class="title">委托协议预览</p>
        <br>
        <p>《职位委托协议》</p>
        <br>
        <p>委托内容如下，供您参考：</p>
        <br>
        <p>关于{{radio==='脱敏'?lvjob.公司:lvjob.简称}} {{lvjob.标题}}职位，第一次正式与我联系的咨询猎头顾问{{account}}</p>
        <br>
        <p>与我详细沟通职位情况后，我对该职位非常感兴趣并独家委托她帮我推荐运作，我认可{{account}}的推荐，希望由该顾问帮我安排后续流程。</p>
        <br>
        <div class="btn-box">
          <el-button size="mini" type="primary" @click="confirm">确认生成协议</el-button>
        </div>
      </div>
    </div>
    <div v-else class="img-content-box">
      <div class="img-content-left">
        <div class="img-left-header">
          <span>扫它，扫它<i class="el-icon-thumb"></i></span>
        </div>
        <div class="img-left-img">
          <img :src="imgUrl" class="lv-img">
        </div>
      </div>
      <div class="img-content-right">
        <p>第一步：使用工作手机扫描左侧小程序码，进入小程序</p>
        <p>第二步：点击【分享】，将小程序分享给候选人</p>
        <p>第三步：让候选人点击【接受委托】</p>
      </div>
      <div class="img-content-footer">
        <el-button size="mini" type="primary" @click="close">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      // dialogVisible: true,
      account: '',
      radio: '脱敏',
      project: {},
      radish: {},
      lvjob: {},
      imgUrl: '',
    }
  },
  mounted(){
    this.account = app.user.account
  },
  methods: {
    open({ pid, rid }){
    // open({ pid="HykfF_xhO", rid="HJhaeqo3B" }){
      if(!pid) return this.$message.error('pid 不存在')
      if(!rid) return this.$message.error('rid 不存在')
      this.radio = '脱敏'
      this.pid = pid
      this.imgUrl = null
      this.dialogVisible = true
      this.getProject(pid)
      this.getRadish(rid)
      this.getLvProject(pid)
    },
    close(){
      this.dialogVisible = false
    },
    async getProject(pid){
      try {
        const data = await app.service('project').fetch(pid)
        this.project = data
      } catch (error) {
        this.$message.error(`projectDetail getProject:${error.message}`)
      }
    },
    async getRadish(rid){
      try {
        const res = await app.service('radish').fetch({ _id:rid })
        this.radish = res.data[0]
      } catch (error) {
        this.$message.error(`projectDetail getProject:${error.message}`)
      }
    },
    async getLvProject(pid){
      const url = `https://nenglijihe.hewa.cn/api/jobs/checkJobDuplicate?coreProjectId=${pid}`
      const res = await window.app.service('misc').urlGet({ url })
      this.lvjob = res.data && res.data.job
    },
    async confirm(){
      try {
        const url = `https://nenglijihe.hewa.cn/api/deliver/getBindRecommendMpCode?hunterId=${this.account}&id=${this.pid}&phoneNumber=${this.radish.手机}`
        const res = await window.app.service('misc').urlGet({ url })
        const wxres = res.data || {}
        if(wxres.status==='success'){
          this.imgUrl = wxres.data && wxres.data.code
        }else this.$message.error(wxres.msg)
        // this.imgUrl = img
      } catch (error) {
        this.$message.error(`projectDetail getProject:${error.message}`)
      }
    },
  },
}
</script>
<style>
/* .radio-box .el-radio__label,
.radio-box .el-radio__input.is-checked+.el-radio__label{
  color: #fff;
} */
</style>
<style scoped>
.recommend-authorization{
  background-color: #979797f0;
  position: fixed;
  z-index: 100000;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  color: #fff;
  align-items: center;
  padding-top: 100px;
}
.authorization-alert-box{
  border: 1px solid #fff;
  width: 482px;
  padding: 10px;
  margin-bottom: 20px;
}
.content-box{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.authorization-box {
  border: 1px solid #fff;
  width: 300px;
  padding: 10px;
}
.radio-box{
  padding: 10px;
}
.btn-box{
  display: flex;
  justify-content: center;
}
.img-content-box {
  display: flex;
  flex-wrap: wrap;
}
.img-content-left {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.img-content-right {
  width: 60%;
}
.img-left-header{
  margin-bottom: 10px;
}
.img-left-header i {
  transform: rotate(180deg);
  margin-left: 10px;
}
.img-content-footer {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 10px;
}
.dialog-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
</style>
